<template>
  <!-- --------------- BEGIN Page Enregistrement coordonnées bancaires --------------- -->
  <div class="m-5 lg:m-15 2xl:m-20 min-h-halfscreen">
    <h3 class="mb-5 lg:mb-15 2xl:mb-20">Offre standard</h3>

    <!-- BEGIN List payment type blocs -->
    <div class="text-left text-xl mb-5 lg:mb-15 2xl:mb-20">
      Comparez et choisissez votre plan de facturation
    </div>

    <div
      class="grid grid-cols-1 gap-2 sm:gap-10 sm:grid-cols-3 mb-5 lg:mb-15 2xl:mb-20"
    >
      <!-- BEGIN Yearly payment bloc -->
      <div
        class="relative group overflow-visible cursor-pointer bg-indigo-200 rounded-md border-2 border-transparent hover:border-indigo-600"
        :class="{
          'border-indigo-600 shadow-indigo': selectedPlan == yearlyPricePlan,
        }"
        @click="selectedPlan = yearlyPricePlan"
      >
        <div
          class="absolute text-sm bg-indigo-600 py-1 px-2 rounded-md text-white uppercase transform left-1/6 -translate-y-1/2"
        >
          1 mois offert
        </div>

        <div
          v-if="selectedPlan == yearlyPricePlan"
          class="absolute flex items-center justify-center h-5 w-5 text-indigo-200 rounded-full right-5 top-5 bg-indigo-600"
        >
          <icon name="checkmark" class="h-2.5 w-2.5" />
        </div>

        <div class="mx-4 mt-4 mb-3 sm:mx-8 sm:mt-8 sm:mb-6">
          <p class="text-xl text-indigo-600">Facturation annuelle</p>
          <div class="flex flex-col mb-2">
            <div class="text-gray-900 flex items-baseline space-x-2">
              <div class="text-3.5xl relative">
                {{ pu1 }}
                <div class="text-2sm absolute -right-2 top-1">€</div>
              </div>
              <div class="text-2sm">
                HT
                <span class="text-sm text-gray-600 font-normal italic">
                  /mois par bénéficiaire
                </span>
              </div>
            </div>
          </div>
          <p class="relative text-2sm">Engagement 12 mois, paiement comptant</p>
        </div>
      </div>
      <!-- END Yearly payment bloc -->

      <!-- BEGIN Monthly payment with commitment bloc -->
      <div
        class="relative group overflow-visible cursor-pointer bg-pink-300 rounded-md border-2 border-transparent hover:border-pink-600"
        :class="{
          'border-pink-600 shadow-pink':
            selectedPlan == monthlyWithComPricePlan,
        }"
        @click="selectedPlan = monthlyWithComPricePlan"
      >
        <div
          class="absolute hidden text-sm bg-pink-600 py-1 px-2 rounded-md text-white uppercase transform left-1/2 -translate-y-1/2"
        >
          économiser 72 €
        </div>

        <div
          v-if="selectedPlan == monthlyWithComPricePlan"
          class="absolute flex items-center justify-center h-5 w-5 text-pink-200 rounded-full right-5 top-5 bg-pink-600"
        >
          <icon name="checkmark" class="h-2.5 w-2.5" />
        </div>

        <div class="mx-4 mt-4 mb-3 sm:mx-8 sm:mt-8 sm:mb-6">
          <p class="text-xl text-pink-600">Facturation mensuelle</p>
          <div class="flex flex-col mb-2">
            <div class="text-gray-900 flex items-baseline space-x-2">
              <div class="text-3.5xl relative">
                {{ pu1 }}
                <div class="text-2sm absolute -right-2 top-1">€</div>
              </div>
              <div class="text-2sm">
                HT
                <span class="text-sm text-gray-600 font-normal italic">
                  /mois par bénéficiaire
                </span>
              </div>
            </div>
          </div>
          <p class="relative text-2sm">Engagement 12 mois, paiement mensuel</p>
        </div>
      </div>
      <!-- END Monthly payment with commitment bloc -->

      <!-- BEGIN Monthly payment bloc -->
      <div
        class="relative group overflow-visible cursor-pointer bg-gray-250 rounded-md border-2 border-transparent hover:border-gray-600"
        :class="{
          'border-gray-600 shadow-gray':
            selectedPlan == monthlyWithoutComPricePlan,
        }"
        @click="selectedPlan = monthlyWithoutComPricePlan"
      >
        <div
          v-if="selectedPlan == monthlyWithoutComPricePlan"
          class="absolute flex items-center justify-center h-5 w-5 text-gray-200 rounded-full right-5 top-5 bg-gray-600"
        >
          <icon name="checkmark" class="h-2.5 w-2.5" />
        </div>

        <div class="mx-4 mt-4 mb-3 sm:mx-8 sm:mt-8 sm:mb-6">
          <p class="text-xl text-black-900">Sans engagement</p>
          <div class="flex flex-col mb-2">
            <div class="text-gray-900 flex items-baseline space-x-2">
              <div class="text-3.5xl relative">
                {{ pu2 }}
                <div class="text-2sm absolute -right-2 top-1">€</div>
              </div>
              <div class="text-2sm">
                HT
                <span class="text-sm text-gray-600 font-normal italic">
                  /mois par bénéficiaire
                </span>
              </div>
            </div>
          </div>
          <p class="relative text-2sm">Sans engagement, paiement mensuel</p>
        </div>
      </div>
      <!-- END Monthly payment bloc -->
    </div>
    <!-- END List payment type blocs -->

    <!-- BEGIN choose payment method + summary -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-20 gap-y-10">
      <!-- BEGIN Billing informations -->
      <div class="col-span-1">
        <!-- BEGIN Nombre NEOPASS -->
        <div class="mb-5 lg:mb-15 2xl:mb-20">
          <div class="text-left text-xl mb-5">
            Choisissez le nombre de Neopass
          </div>
          <input-text
            name="NombreNeopassSouscris"
            libelle="Nombre de Neopass"
            type="number"
            :value="nbNeopassSubscribed"
            @input="
              (newValue) => {
                nbNeopassSubscribed = newValue;
              }
            "
            class="lg:w-full"
            :error="true"
            :msg-error="((errors || []).nbNeopass || [])[0]"
            :min="0"
          />
          <div
            v-if="nbNeopassForNextMilestone > 0 && nbNeopassSubscribed > 0"
            class="text-teal-600 text-sm"
          >
            plus que {{ nbNeopassForNextMilestone }} Neopass pour bénéficier
            d'une remise complémentaire à votre offre actuelle
          </div>

          <checkbox-indigo
            name="devisFormation"
            libelle="Je souhaite être contacté par téléphone, afin d’obtenir un devis concernant les formations Neopass."
            :value="devisFormation"
            @input="
              (newValue) => {
                devisFormation = newValue;
              }
            "
            class="lg:w-full mt-4"
          />
          <input-text
            v-if="devisFormation"
            name="phoneNumber"
            libelle="Numéro de télephone *"
            type="tel"
            :value="phoneNumber"
            @input="
              (newValue) => {
                phoneNumber = newValue;
              }
            "
            class="lg:w-1/2 mt-4"
            :error="true"
            :msg-error="((errors || []).phoneNumber || [])[0]"
            :maxlength="10"
          />
        </div>
        <!-- END Nombre NEOPASS -->

        <!-- BEGIN Payment Method -->
        <div class="mb-5 lg:mb-15 2xl:mb-20">
          <div class="text-left text-xl mb-5">Méthode de paiement</div>
          <!-- BEGIN Create Payment Method Form -->
          <div v-show="paymentMethods.length == 0" class="mb-10">
            <input-text
              class="mb-4"
              id="card-holder-name"
              name="name"
              libelle="Nom du titulaire de la carte"
              :value="name"
              @input="
                (newValue) => {
                  name = newValue;
                }
              "
            />
            <div class="relative w-full mb-4">
              <p class="text-sm text-gray-600 cursor-default truncate mb-2">
                Numéro de la carte bancaire
              </p>
              <div
                class="bg-white border border-indigo-600 h-11 rounded-md placeholder-gray-600 text-gray-900 font-medium focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 transition duration-150 ease-in-out text-sm px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4"
                id="card-number-element"
              ></div>
            </div>
            <div class="w-full flex">
              <div class="relative w-1/2 mr-4">
                <p class="text-sm text-gray-600 cursor-default truncate mb-2">
                  Date d'expiration de la carte
                </p>
                <div
                  class="bg-white border h-11 border-indigo-600 rounded-md placeholder-gray-600 text-gray-900 font-medium focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 transition duration-150 ease-in-out text-sm sm:leading-5 px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4"
                  id="card-expiry-element"
                ></div>
              </div>
              <div class="relative w-1/2">
                <p class="text-sm text-gray-600 cursor-default truncate mb-2">
                  CVC
                </p>
                <div
                  class="bg-white border h-11 border-indigo-600 rounded-md placeholder-gray-600 text-gray-900 font-medium focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 transition duration-150 ease-in-out text-sm sm:leading-5 px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4"
                  id="card-cvc-element"
                ></div>
              </div>
            </div>
            <!--
                        <div v-if="saving" id="add-card-button" class="  w-1/2">
                          <action-button
                            borderColor="border-transparent"
                            textColor="text-white"
                            textColorHover="hover:text-indigo-600"
                            bgColor="bg-indigo-600"
                            bgColorHover="hover:bg-indigo-300"
                            bgColorSquare="bg-indigo-600"
                            iconColor="text-white"
                            iconColorHover="hover:text-indigo-600"
                            libelle="Utiliser cette carte"
                            icon="checkmark"
                            :right="true"
                            :spinner="true"
                            :responsive="false"
                          />
                        </div>
                        <div v-else id="add-card-button" class="  w-1/2" @click="submitPaymentMethod()">
                          <action-button
                            borderColor="border-transparent"
                            textColor="text-white"
                            textColorHover="hover:text-indigo-600"
                            bgColor="bg-indigo-600"
                            bgColorHover="hover:bg-indigo-300"
                            bgColorSquare="bg-indigo-600"
                            iconColor="text-white"
                            iconColorHover="hover:text-indigo-600"
                            libelle="Utiliser cette carte"
                            icon="checkmark"
                            :right="true"
                            :spinner="false"
                            :responsive="false"
                          />
                        </div> -->
          </div>
          <!-- END Create Payment Method Form -->

          <!-- BEGIN Already saved Payment Method check -->
          <div
            class="mb-10 w-10/12"
            v-show="paymentMethodsLoadStatus == 2 && paymentMethods.length > 0"
          >
            <div
              v-for="(method, key) in paymentMethods"
              :key="'method-' + key"
              @click="paymentMethodSelected = method.id"
              class="border rounded row p-1"
              :class="{
                'bg-success text-light': paymentMethodSelected == method.id,
              }"
            >
              <div class="w-full m-3 text-sm">
                <span class="font-semibold"
                  >{{ method.brand.charAt(0).toUpperCase()
                  }}{{ method.brand.slice(1) }}</span
                >
              </div>
              <div class="w-full m-3 text-sm">
                <span class="font-semibold">Numéro de la carte bancaire :</span>
                **** **** **** {{ method.last_four }}
              </div>
              <div class="w-full m-3 text-sm">
                <span class="font-semibold">Date d'expiration :</span>
                {{ method.exp_month }} / {{ method.exp_year }}
              </div>
              <div class="w-full m-3">
                <action-button
                  border-color="border-transparent"
                  text-color="text-white"
                  bg-color="bg-pink-600"
                  bg-color-square="bg-pink-600"
                  icon-color="text-white"
                  libelle="Changer de carte bancaire"
                  icon="credit-card"
                  :spinner="saving"
                  :responsive="false"
                  @clickAction="removePaymentMethod(method.id)"
                />
              </div>
            </div>
          </div>
          <!-- END Already saved Payment Method check -->
        </div>
        <!-- END Payment Method -->
        <!-- BEGIN billing detail informations -->
        <div>
          <div class="text-left text-xl mb-5">Détails de facturation</div>
          <input-text
            name="companyName"
            libelle="Nom de l'organisme"
            :value="billingInfos.organisationName"
            @input="
              (newValue) => {
                billingInfos.organisationName = newValue;
              }
            "
            class="w-full mb-4"
            :error="true"
            :msg-error="
              ((errors || [])['billingInfos.organisationName'] || [])[0]
            "
          />
          <input-text
            name="companyAddress"
            libelle="Adresse"
            :value="billingInfos.address"
            @input="
              (newValue) => {
                billingInfos.address = newValue;
              }
            "
            class="w-full mb-4"
            :error="true"
            :msg-error="((errors || [])['billingInfos.address'] || [])[0]"
          />
          <div class="flex">
            <input-text
              name="companyPostalCode"
              libelle="Code postal"
              :value="billingInfos.postalCode"
              @input="
                (newValue) => {
                  billingInfos.postalCode = newValue;
                }
              "
              class="lg:w-1/2 mr-4"
              :error="true"
              :msg-error="((errors || [])['billingInfos.postalCode'] || [])[0]"
            />
            <input-text
              name="companycity"
              libelle="Ville"
              :value="billingInfos.city"
              @input="
                (newValue) => {
                  billingInfos.city = newValue;
                }
              "
              class="lg:w-1/2"
              :error="true"
              :msg-error="((errors || [])['billingInfos.city'] || [])[0]"
            />
          </div>
        </div>
        <!-- END billing detail informations -->
      </div>
      <!-- END Billing informations -->

      <!-- BEGIN Summary billing -->
      <div class="col-span-1">
        <div class="bg-gray-250 shadow-gray p-12">
          <div class="text-xl text-left">Récapitulatif de votre commande</div>
          <ul class="my-5 text-base text-normal">
            <li class="flex">
              <icon
                name="checkmark-circle"
                class="text-indigo-600 mb-3 mr-3 w-6 h-6"
              />
              <span class="text-gray-600 mt-0.5">Offre Standard</span>
            </li>
            <li v-if="selectedPlan == yearlyPricePlan" class="flex">
              <icon
                name="checkmark-circle"
                class="text-indigo-600 mb-3 mr-3 w-6 h-6"
              />
              <span class="text-gray-600 mt-0.5">Facturation annuelle</span>
            </li>
            <li
              v-else-if="
                selectedPlan == monthlyWithComPricePlan ||
                selectedPlan == monthlyWithoutComPricePlan
              "
              class="flex"
            >
              <icon
                name="checkmark-circle"
                class="text-indigo-600 mb-3 mr-3 w-6 h-6"
              />
              <span class="text-gray-600 mt-0.5">Facturation mensuelle</span>
            </li>
            <li
              v-if="
                selectedPlan == yearlyPricePlan ||
                selectedPlan == monthlyWithComPricePlan
              "
              class="flex"
            >
              <icon
                name="checkmark-circle"
                class="text-indigo-600 mb-3 mr-3 w-6 h-6"
              />
              <span class="text-gray-600 mt-0.5">Engagement 12 mois</span>
            </li>
            <li
              v-else-if="selectedPlan == monthlyWithoutComPricePlan"
              class="flex"
            >
              <icon
                name="checkmark-circle"
                class="text-indigo-600 mb-3 mr-3 w-6 h-6"
              />
              <span class="text-gray-600 mt-0.5">Sans engagement</span>
            </li>
            <li class="flex">
              <icon
                name="checkmark-circle"
                class="text-indigo-600 mr-3 w-6 h-6"
              />
              <span class="text-gray-600 mt-0.5"
                >{{ nbNeopassSubscribed }} Neopass</span
              >
            </li>
          </ul>

          <div
            class="border-t border-opacity-50 border-indigo-600 border-dashed my-10"
          ></div>

          <h5 class="text-left text-xl mb-5">Paiement aujourd'hui</h5>

          <div
            :class="{
              'mb-0.5': selectedPlan == yearlyPricePlan,
              'mb-5':
                selectedPlan == monthlyWithoutComPricePlan ||
                selectedPlan == monthlyWithComPricePlan,
            }"
          >
            <!-- Avec engagement -->
            <p
              v-if="
                selectedPlan == yearlyPricePlan ||
                selectedPlan == monthlyWithComPricePlan
              "
              class="text-base text-gray-600"
            >
              <span v-if="selectedPlan == yearlyPricePlan"
                >{{ pu1 }} € x 12 mois =
                {{
                  (12 * priceUnit).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })
                }}
                € / bénéficiaire</span
              >
              <span v-else-if="selectedPlan == monthlyWithComPricePlan"
                >{{ pu1 }} € / bénéficiaire</span
              >
            </p>
            <!-- Sans engagement -->
            <p
              v-if="selectedPlan == monthlyWithoutComPricePlan"
              class="text-base text-gray-600"
            >
              {{ pu2 }} € / bénéficiaire
            </p>
            <!-- Annuel -->
            <p
              v-if="selectedPlan == yearlyPricePlan"
              class="text-base text-gray-600"
            >
              1 mois offert à {{ pu1 }} €, soit un total de
              {{
                (12 * priceUnit - priceUnit).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })
              }}
              €
            </p>
          </div>
          <div class="mb-5">
            <!-- Annuel -->
            <span
              v-if="selectedPlan == yearlyPricePlan"
              class="text-4xl text-indigo-600 mr-2"
            >
              {{
                (
                  (12 * priceUnit - priceUnit) *
                  nbNeopassSubscribed
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })
              }}
              € <span class="text-lg">HT</span>
            </span>
            <!-- Mensuel avec engagement -->
            <span
              v-if="selectedPlan == monthlyWithComPricePlan"
              class="text-4xl text-indigo-600 mr-2"
            >
              {{
                (priceUnit * nbNeopassSubscribed).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })
              }}
              € <span class="text-lg">HT</span>
            </span>
            <!-- Mensuel sans engagement -->
            <span
              v-else-if="selectedPlan == monthlyWithoutComPricePlan"
              class="text-4xl text-indigo-600 mr-2"
            >
              {{
                (priceUnit2 * nbNeopassSubscribed).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })
              }}
              € <span class="text-lg">HT</span>
            </span>
            <span class="text-base text-gray-600"
              >pour {{ nbNeopassSubscribed }} bénéficiaires</span
            >
          </div>
          <div
            class="border-t border-opacity-50 border-indigo-600 border-dashed my-10"
          ></div>
          <div class="flex mb-10">
            <checkbox-gray
              name="conditions"
              :value="confirmConditions"
              @input="
                (newValue) => {
                  confirmConditions = newValue;
                }
              "
              class="mr-2"
            />
            <p class="text-base font-light text-gray-600">
              J’accepte les
              <a
                class="underline"
                href="https://www.neopass.fr/conditions-generales-de-vente/"
                target="_blank"
                >Conditions Générales de Ventes</a
              >
              et la
              <a
                class="underline"
                href="https://www.neopass.fr/politique-de-confidentialite%e2%80%8b/"
                target="_blank"
                >Politique de Confidentialité</a
              >.
            </p>
          </div>
          <div class="flex justify-center">
            <action-button
              v-if="!saving"
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              bg-color-square="bg-pink-600"
              icon-color="text-white"
              libelle="COMMANDER"
              :uppercase="true"
              icon="shopping-cart"
              type-shadow="shadow-pink"
              @clickAction="subscribe"
            />
            <action-button
              v-else
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              bg-color-square="bg-pink-600"
              icon-color="text-white"
              libelle="COMMANDER"
              :uppercase="true"
              :spinner="true"
              icon="shopping-cart"
              type-shadow="shadow-pink"
            />
          </div>
          <!-- display errors -->
          <ul class="text-sm text-pink-600 w-full mt-5 list-disc">
            <li
              v-for="(err, index) in Object.fromEntries(
                Object.entries(errors).filter(([key, val]) =>
                  ['plan', 'conditions'].includes(key)
                )
              )"
              :key="index"
              class="m-2"
            >
              {{ err[0] }}
            </li>
          </ul>
        </div>
      </div>
      <!-- END Summary billing -->
    </div>
  </div>
  <!-- --------------- END Page Enregistrement coordonnées bancaires --------------- -->
</template>
<script>
import axios from './../../api';
import store from './../../store';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Constants from './../../constants';
import Illustration from './../../components/Illustration';
import Icon from './../../components/Icon';
import ActionButton from './../../components/ActionButton';
import Popup from './../../components/Popup';
import InputText from './../../components/Inputs/InputText';
import InputSelect from './../../components/Inputs/InputSelect';
import CircleButton from './../../components/CircleButton';
import CheckboxIndigo from './../../components/Inputs/CheckboxIndigo';
import CheckboxGray from './../../components/Inputs/CheckboxGray';

export default {
  name: 'SubscriptionChoice',

  components: {
    Icon,
    ActionButton,
    Illustration,
    InputText,
    CircleButton,
    Popup,
    InputSelect,
    CheckboxGray,
    CheckboxIndigo,
  },

  data() {
    return {
      /* BEGIN datas for "mes abonnements" */
      subscription: {},
      volumeNeopass: {
        total: 0,
        created: 0,
        active: 0,
        inactive: 0,
        suspended: 0,
        available: 0,
      },
      billingInfos: {
        organisationName: '',
        address: '',
        postalCode: '',
        city: '',
      },
      confirmConditions: false,

      yearlyPricePlan: process.env.MIX_PRICE_PLAN_YEARLY,
      monthlyWithComPricePlan:
        process.env.MIX_PRICE_PLAN_MONTHLY_WITH_COMMITMENT,
      monthlyWithoutComPricePlan:
        process.env.MIX_PRICE_PLAN_MONTHLY_WITHOUT_COMMITMENT,

      nbNeopassSubscribed: 0,
      nbNeopassForNextMilestone: 0,
      stripeAPIToken: process.env.MIX_STRIPE_KEY,
      //selectedPlan: process.env.MIX_PRICE_PLAN_YEARLY,
      selectedPlan: null,
      stripe: '',
      elements: '',
      //card: '',
      intentToken: '',

      name: '',
      cardNumber: '',
      cardExpiry: '',
      cardCvc: '',

      addPaymentStatus: 0,
      addPaymentStatusError: '',

      paymentMethods: [],
      paymentMethodsLoadStatus: 0,
      paymentMethodSelected: null,

      errors: {},

      devisFormation: false,
      phoneNumber: '',
      /* END datas for "mes abonnements" */

      constants: Constants,
    };
  },

  mounted() {
    this.includeStripe(
      'js.stripe.com/v3/',
      function () {
        this.configureStripe();
      }.bind(this)
    );

    this.loadIntent();
    this.loadPaymentMethods();

    this.loadSubscription();

    let user = store.getters['auth/user'];

    if (user.companies.length > 0) {
      this.billingInfos.organisationName = user.companies[0].name;
      if (user.companies[0].address != null) {
        this.billingInfos.address = user.companies[0].address;
      }
    }
  },

  methods: {
    ...mapMutations({
      SET_TABDISPLAY: 'account/SET_TABDISPLAY',
      SET_SAVING: 'account/SET_SAVING',
    }),

    loadSubscription() {
      axios.get('/api/subscription/subscription').then((response) => {
        this.nbNeopassSubscribed = 0;

        if (response.data) {
          //if subscription exists
          this.subscription = response.data;

          //perhaps have multi subscriptions
          this.subscription.forEach((sub) => {
            if (sub.quantity > 0) {
              this.nbNeopassSubscribed += sub.quantity;
            }
          });
          store.commit('auth/SET_SUBSCRIPTION', this.subscription[0]);
        }
        if (this.nbNeopassSubscribed > 0) {
          this.changeVolumeNeopass(this.nbNeopassSubscribed);
        } else {
          this.changeVolumeNeopass(100);
          this.nbNeopassSubscribed = 0;
        }
      });
    },
    changeVolumeNeopass(total) {
      axios.get('/api/allNeopass').then((response) => {
        let allPass = response.data;

        this.volumeNeopass.total = total;
        this.volumeNeopass.created = allPass.filter(
          (p) => p.deleted_at == null
        ).length;
        this.volumeNeopass.active = allPass.filter(
          (p) => p.is_active == 1 && p.deleted_at == null
        ).length;
        this.volumeNeopass.inactive = allPass.filter(
          (p) => p.deleted_at != null
        ).length;
        this.volumeNeopass.suspended = allPass.filter(
          (p) => p.is_active == 0 && p.deleted_at == null
        ).length;
        this.volumeNeopass.available =
          this.volumeNeopass.total - this.volumeNeopass.created;
      });
    },
    /*
            Includes Stripe.js dynamically
          */
    includeStripe(URL, callback) {
      let documentTag = document,
        tag = 'script',
        object = documentTag.createElement(tag),
        scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) {
        object.addEventListener(
          'load',
          function (e) {
            callback(null, e);
          },
          false
        );
      }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },

    /*
            Configures Stripe by setting up the elements and
            creating the card element.
          */
    configureStripe() {
      this.stripe = Stripe(this.stripeAPIToken);

      this.elements = this.stripe.elements();

      /*         this.card = this.elements.create('card');
              this.card.mount('#card-element'); */

      this.cardNumber = this.elements.create('cardNumber');
      this.cardNumber.mount('#card-number-element');

      this.cardExpiry = this.elements.create('cardExpiry');
      this.cardExpiry.mount('#card-expiry-element');

      this.cardCvc = this.elements.create('cardCvc');
      this.cardCvc.mount('#card-cvc-element');
    },

    /*
            Loads the payment intent key for the user to pay.
          */
    loadIntent() {
      axios.get('/api/subscription/setup-intent').then(
        function (response) {
          this.intentToken = response.data;
        }.bind(this)
      );
    },
    async subscribe() {
      if (!this.isAdminPay) return;

      this.SET_SAVING(true);
      this.addPaymentStatus = 2;

      console.log('wait...subscription in progress');
      store.commit('app/SET_LOADING', true);
      try {
        let { data } =
          (await axios.put('/api/subscription/subscription', {
            billingInfos: this.billingInfos,
            plan: this.selectedPlan,
            payment: this.paymentMethodSelected,
            nbNeopass: this.nbNeopassSubscribed,
            conditions: this.confirmConditions,
            devisFormation: this.devisFormation,
            phoneNumber: this.phoneNumber,
          })) || {};

        if (data.payment_intent) {
          // We need to setup payment method

          this.intentToken = data.payment_intent;

          const payment = await this.stripe.confirmCardPayment(
            this.intentToken,
            {
              setup_future_usage: 'off_session',
              payment_method: {
                card: this.cardNumber,
                billing_details: {
                  name: this.name,
                },
              },
            }
          );

          await axios.post('/api/subscription/payments', {
            payment_method: payment.paymentIntent.payment_method,
          });

          // Replay subscription as the payment method was confirmed
          ({ data } = await axios.put('/api/subscription/subscription', {
            resumeIncomplete: true,
            billingInfos: this.billingInfos,
            plan: this.selectedPlan,
            payment: this.paymentMethodSelected,
            nbNeopass: this.nbNeopassSubscribed,
            conditions: this.confirmConditions,
            devisFormation: this.devisFormation,
            phoneNumber: this.phoneNumber,
          }));
        }

        store.commit('auth/SET_SUBSCRIPTION', data[0]);

        //update role
        axios.get('/api/role/name').then(
          function (response) {
            store.commit('auth/SET_ROLE', response.data);
            store.dispatch('auth/me');
            this.SET_SAVING(false);
            store.commit('app/SET_LOADING', false);

            //redirect to subscription page
            this.$router.push(
              '/parametres-de-compte/mon-abonnement?subscriptionSuccess=1'
            );
          }.bind(this)
        );
      } catch (error) {
        console.log('ERRRR:: ', error.response?.data?.errors || error);
        if (error.response.status == 403) {
          alert("Vous n'êtes pas autorisé à effectuer cette action");
        }
        this.errors = error.response.data.errors;
        this.loadPaymentMethods(); //load new payment method if it's validate
        this.SET_SAVING(false);
        store.commit('app/SET_LOADING', false);
      }
    },

    /*
            Loads all of the payment methods for the user.
        */
    loadPaymentMethods() {
      store.commit('app/SET_LOADING', true);
      this.paymentMethodsLoadStatus = 1;
      axios.get('/api/subscription/payment-methods').then(
        function (response) {
          this.paymentMethods = response.data;
          if (this.paymentMethods.length > 0) {
            this.paymentMethodSelected = this.paymentMethods[0].id;
          }
          this.paymentMethodsLoadStatus = 2;
          store.commit('app/SET_LOADING', false);
        }.bind(this)
      );
    },

    removePaymentMethod(paymentID) {
      store.commit('app/SET_LOADING', true);
      if (this.isAdminPay) {
        axios
          .post('/api/subscription/remove-payment', {
            id: paymentID,
          })
          .then(
            function (response) {
              this.paymentMethodSelected = null;
              this.loadPaymentMethods();
            }.bind(this)
          );
      }
      store.commit('app/SET_LOADING', false);
    },

    updateSubscription() {
      store.commit('app/SET_LOADING', true);
      if (this.isAdminPay) {
        console.log('wait...subscription in progress');
        axios
          .put('/api/subscription/subscription', {
            plan: this.selectedPlan,
            payment: this.paymentMethodSelected,
            quantity: this.nbNeopassSubscribed,
            conditions: this.confirmConditions,
          })
          .then(
            function (response) {
              console.log('wait...update subscription');
            }.bind(this)
          );
      }
      store.commit('app/SET_LOADING', false);
    },
  },

  computed: {
    ...mapGetters({
      isAdminPay: 'account/isAdminPay',
      tab_display: 'account/tabDisplay',
      saving: 'account/saving',
    }),
    qtNeopassPossible: function () {
      // To fill the select input with quantity of Neopass to subscribe
      let qt = [];
      let limit = 99;
      //var max = limit - this.nbNeopassSubscribed; // In case, we want to limit nb neopass at 100 per admin payer

      for (let index = 0; index < limit; index++) {
        qt.push({ value: index + 1 });
      }
      return qt;
    },

    priceUnit: function () {
      // Paliers de prix en fonction du nombre de Neopass choisi
      let milestones = Constants.MILESTONES_WITH_COMMITMENT_UNIT_PRICE;

      return (
        milestones[
          Object.keys(milestones)
            .filter((qt) => parseInt(this.nbNeopassSubscribed) >= qt)
            .reverse()[0]
        ] || 9.9
      );
    },
    pu1: function () {
      // Prix unitaire avec engagement (sous forme décimale à 2 chiffres après la virgule)
      return this.priceUnit.toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });
    },

    priceUnit2: function () {
      // Paliers de prix en fonction du nombre de Neopass choisi
      let milestones = Constants.MILESTONES_WITHOUT_COMMITMENT_UNIT_PRICE;

      return (
        milestones[
          Object.keys(milestones)
            .filter((qt) => parseInt(this.nbNeopassSubscribed) >= qt)
            .reverse()[0]
        ] || 12.9
      );
    },
    pu2: function () {
      // Prix unitaire sans engagement (sous forme décimale à 2 chiffres après la virgule)
      return this.priceUnit2.toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });
    },
  },

  watch: {
    nbNeopassSubscribed(newValue) {
      if (this.nbNeopassSubscribed === 0) {
        return;
      }

      let milestones = [0, 25, 50, 100, 200];
      let newIntValue = parseInt(newValue);

      let listNextMilestones = milestones.filter(
        (qt) => newIntValue < qt && !milestones.includes(newIntValue)
      );

      if (listNextMilestones.length === 0) {
        this.nbNeopassForNextMilestone = 0;
        return;
      }
      if (listNextMilestones.length > 0) {
        let nextMilestone = listNextMilestones[0];
        this.nbNeopassForNextMilestone = nextMilestone - newIntValue;
      }
    },
  },
};
</script>
